const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

//Action to save and fetch data
import { buyvotesPayment, fetchallposts, frontimmute } from '../../actions/front_actions';

import FavoriteIcon from "@mui/icons-material/Favorite";
import VisibilityIcon from '@mui/icons-material/Visibility';

import ContestantImage from './ContestantImage.jsx';
import VideoContestant from './VideoContestant.jsx';
import Paginationcontestants from './Paginationcontestants.jsx';
import VoteButton from './VoteButton.jsx';
import Showallactions from './Showallactions.jsx';
import CriticalError from '../CriticalError.jsx';

import {
    Typography,
    Grid2,
    Card,
    CardHeader,
    CardActions,
    Link,
    Backdrop,
    CircularProgress,
} from '@mui/material';

let current_date = null;
class ShowallContestGrid extends Component {
    constructor(props) {
        super(props);
        this._isMounted = false;
        this.state = { anchorEl: '', wait: 1, page_number: 1, gtitle_color: '', listgrid: "grid" };
        this.contestantsContainer = React.createRef();
    }

    componentWillUnmount = () => {
        this._isMounted = false;
    }

    componentDidMount = () => {
        this._isMounted = true;
        this.setState({ wait: 1 });
        this.handleUpdateposts();
    }

    componentDidUpdate(prevProps, prevState) {
        if ((prevProps.category_term !== this.props.category_term) || (prevProps.sort_order !== this.props.sort_order) || (prevProps.search_text !== this.props.search_text)) {
            this.setState({ wait: 1 });
            this.handleUpdateposts(this.props.category_term, this.props.sort_order, null, '', this.props.search_text);
        }
    }

    handleUpdateposts = async (category_id, sortorder, pagin, way_paging, search) => {
        if (this.props.term_id && this.props.posts) {
            this.setState({ wait: 0 });
            return;
        }
        pagin = (pagin != null && typeof pagin !== "undefined") ? pagin : 1;
        if ((typeof category_id !== "undefined" && category_id != 0) || (typeof sortorder !== "undefined" && sortorder != 0) || (typeof search !== "undefined" && search != '')) {
            let short_atrr = this.props.short;
            short_atrr.search_text = (typeof search !== "undefined") ? search : '';
            if (sortorder == 'new') {
                short_atrr.orderby = "date";
                short_atrr.order = "desc";
            }
            if (sortorder == 'old') {
                short_atrr.orderby = "date";
                short_atrr.order = "asc";
            }
            let category_upd = null;
            if ((typeof category_id !== "undefined" && category_id != 0)) {
                category_upd = category_id;
            }
            this.props.fetchallposts(this.props.SITE_URL, category_upd, short_atrr, pagin, way_paging).then(res => {
                if (this._isMounted) { this.setState({ wait: 0 }); }
            });
        } else {
            this.props.fetchallposts(this.props.SITE_URL, null, this.props.short, pagin, way_paging).then(res => {
                if (this._isMounted) { this.setState({ wait: 0 }); }
            });
        }
    }


    pagination = (event, value) => {
        // this.setState({ wait: 1 });
        if (!Number.isInteger(value)) {
            value = event.target.value;
        }
        this.props.frontimmute('allpaginateval', value);
        this.handleUpdateposts(this.props.category_term, this.props.sort_order, value).then(res => {
            if (this._isMounted) {
                this.setState({ page_number: value });
                this.contestantsContainer.current.scrollIntoView({ behavior: 'smooth' });
            }
        });
    }

    paginationbtn = (btn, value) => {
        // this.setState({ wait: 1 });
        if (btn == 'button') {
            value = value + 1;
        }
        this.handleUpdateposts(this.props.category_term, this.props.sort_order, value, 'load').then(res => {
            if (this._isMounted) { this.setState({ page_number: value }); }
        });
    }

    render() {
        const { t } = this.props;
        const { votes_cont_title_font_size, votes_cont_title_color_hover, box_bgcolor } = this.props.settings.color;
        const posts = this.props.post.posts ? this.props.post.posts : this.props.posts;
        const allprops = this.props;
        if (this.props.criticalError !== undefined) {
            return <CriticalError msg={this.props.criticalError} />
        }
        if ((posts != null && typeof posts === 'object') && (posts.length > 0) && (this.state.wait != 1)) {
            current_date = new Date(posts.current_date);
            let current_posts = posts;
            if (allprops.term_id) {
                current_posts = posts.filter(post => post.term_id == allprops.term_id);
            }
            return (
                (<Grid2 container className="wpvc_showcontestant_container" ref={this.contestantsContainer}>
                    <Grid2 container size={12} direction="row" spacing={3} className="wpvc_show_style">

                        {current_posts.map((object, i) => {
                            let index = i;
                            if (allprops.term_id) {
                                index = posts.findIndex(post => post.id === object.id);
                            }
                            return (
                                (<Grid2
                                    key={i}
                                    className={object.allcatoption?.style?.imageProportion === 'on' ? 'wpvc_show_style_row wpvc_image_proportion' : 'wpvc_show_style_row'}
                                    size={{
                                        xs: object.allcatoption?.style?.imageProportion === 'on' ? 'auto' : 12,
                                        md: object.allcatoption?.style?.imageProportion === 'on' ? 4 : 4
                                    }}>
                                    <Card className="wpvc_card_row wpvc_showall_container" style={{ backgroundColor: box_bgcolor || '#FFF' }}>

                                        <CardHeader
                                            className="wpvc_card_show_header"
                                            title={<Link underline='none' style={{ fontSize: votes_cont_title_font_size + 'px', 'color': votes_cont_title_color_hover }} href={object?.link}>{object.post_title}</Link>}
                                        />

                                        {(object.img_contest == "photo" || object.img_contest == "essay") &&
                                            <ContestantImage {...allprops} showallpage={1} short={object} singlepost={object} all_contest={1} indexpost={index} view={this.props.view} />
                                        }
                                        {(object.img_contest == "video" || object.img_contest == "music") &&
                                            <VideoContestant {...allprops} singlepost={object} all_contest={1} indexpost={index} view={this.props.view} />
                                        }

                                        <CardActions disableSpacing>
                                            <Grid2 container size={12} direction="row">
                                                <Grid2 size={8} >
                                                    <Grid2 container className="wpvc_allcontest_action" direction="row">
                                                        {object.vote_button_status != 'ended' && object.vote_button_status != 'not_started' &&
                                                            <VoteButton {...allprops} singlepost={object} indexpost={index} view={this.state.listgrid} allcontest={1} termid={object.term_id} currentdate={current_date} wait={this.state.wait} />
                                                        }
                                                        <Showallactions {...allprops} singlepost={object} indexpost={index} view={this.state.listgrid} allcontest={1} termid={object.term_id} />
                                                    </Grid2>
                                                </Grid2>
                                                <Grid2 className="wpvc_card_allcontest_actions" size={4}>
                                                    <Typography className="wpvc_card_show_actions_single">
                                                        <VisibilityIcon /><span>{object.votes_viewers}</span>
                                                    </Typography>
                                                    <Typography className="wpvc_card_show_actions_single">
                                                        <FavoriteIcon /><span>{object.votes_count}</span>
                                                    </Typography>
                                                </Grid2>
                                            </Grid2>
                                        </CardActions>
                                    </Card>
                                </Grid2>)
                            );
                        }
                        )}
                        {current_posts.length == 0 &&
                            <Grid2 container className="wpvc_hr_contestants" >
                                <Typography align="center" variant="h6" component="h6">{t("no_contestants_found")}</Typography>
                            </Grid2>
                        }
                        <Paginationcontestants
                            {...allprops}
                            pagenumber={this.state.page_number}
                            changepagin={this.pagination}
                            changepaginbtn={this.paginationbtn}
                            select_value={this.props.allpaginateval}
                        />
                    </Grid2>
                </Grid2>)
            );
        }
        else if (posts == 'perpage') {
            return '';
        }
        else if (posts && posts.current_date && (this.state.wait != 1)) {
            return '';
        }
        else if (this.props.index > 0) {
            return '';
        }
        else {
            return <Backdrop className="wpvc_back_loader" open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        }

    }
}

const settingstate = state => {
    return { post: state.wpvcfrontdata };
}

export default connect(settingstate, { buyvotesPayment, fetchallposts, frontimmute })(withTranslation("translations")(ShowallContestGrid));